import { render, staticRenderFns } from "./FeedbackRetention.vue?vue&type=template&id=2e5d83c3&"
import script from "./FeedbackRetention.vue?vue&type=script&lang=js&"
export * from "./FeedbackRetention.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackRetention.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports